import { render, staticRenderFns } from "./DashboardFranqFinder.vue?vue&type=template&id=1b78cb0c"
import script from "./DashboardFranqFinder.vue?vue&type=script&lang=js"
export * from "./DashboardFranqFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports